import { Fragment } from "react";
import "./Web3Consulting.css";
import { web3Marketing } from "../../staticdata";
import web3consultingbanner from "../../assets/images/services/web3/web3consultingbanner.jpg";


const Web3Consulting = () => {
  return (
    <Fragment>
      <section className="web3consulting-style">
        <div className="web3consulting-banner">
          <div className="row">
            <div className="col-lg-6">
              <div className="web3consulting-desc">
                <h1
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Web3 Consulting Services
                </h1>
                <p
                  className="text-start"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  As one of the leading Web3 consulting agencies, we offer
                  infallible solutions to help your project stand out, attract
                  the right audience, and achieve sustainable growth. Kairaa
                  holds a proven track record as the best Web3 consulting agency,
                  helping brands like yours gain traction, grow communities, and
                  drive real adoption.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="image-blend-wrapper"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={web3consultingbanner}
                  alt="image not found"
                  loading="lazy"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="web3consulting-services">
          <div className="container">
            <div
              className="section-title mt-5 mb-5"
              data-aos="fade-down"
              data-aos-duration="800"
            >
              <h2 className="text-center">
                Our{" "}
                <span className="title-gradient">Web3 Consulting </span>{" "}
                Service
              </h2>
            </div>
            <div className="row gy-4 d-flex justify-content-center">
              {web3Marketing.map((services, index) => (
                <div
                  className="col-lg-4 col-md-6"
                  key={services.id}
                  data-aos="zoom-in"
                >
                  <div className="web3consulting-card">
                    <div className="icon-wrap">
                      <img
                        src={services.icon}
                        alt="img not found"
                        style={{ width: "62px", height: "62px" }}
                      />
                    </div>
                    <h5>{services.title}</h5>
                    <p className="text-light mb-0">{services.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default Web3Consulting;
